<template>
  <div id="app">
    <app-header v-if="header_show"></app-header>
    <transition name='fade' mode="out-in">
      <keep-alive>
    <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive" v-on:header="header" v-on:footer="footer"></router-view>
      </keep-alive>
    </transition>
    <transition name='fade' mode="out-in">
      <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
    </transition>
    <app-footer v-if="footer_show"></app-footer>


  </div>
</template>

<script>

import Header from './components/common/Header'
import Footer from "./components/common/Footer";
export default {
  name: 'App',
  data(){
    return {
      header_show:true,
      footer_show:true,
    }
  },
  components: {
    'app-header':Header,
    'app-footer':Footer,
  },
  methods:{
    //是否显示头部
    header:function (bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer:function (bool) {
      this.footer_show = bool;
    }
  }

}
</script>





// WEBPACK FOOTER //
// src/App.vue